import React, { useState, useEffect } from 'react';

const BOOT_MESSAGES = [
  { text: '', delay: 100 },
  { text: 'TUX OS BIOS v3.14.159', delay: 200 },
  { text: 'Copyright (c) 2024 TUX Foundation', delay: 150 },
  { text: '', delay: 100 },
  { text: 'Detecting hardware...', delay: 300 },
  { text: '  CPU: Penguin Core i9-TUX @ 4.20GHz', delay: 150 },
  { text: '  RAM: 69420 MB OK', delay: 100 },
  { text: '  GPU: NVIDIA GeForce TUX 4090', delay: 100 },
  { text: '', delay: 100 },
  { text: 'Starting TUX OS boot sequence...', delay: 200 },
  { text: '', delay: 50 },
  { text: '[  OK  ] Started Load Kernel Modules', delay: 80 },
  { text: '[  OK  ] Started udev Coldplug all Devices', delay: 80 },
  { text: '[  OK  ] Reached target Local File Systems', delay: 80 },
  { text: '[  OK  ] Started Permit User Sessions', delay: 80 },
  { text: '[  OK  ] Started Network Manager', delay: 80 },
  { text: '[  OK  ] Mounting /dev/sda1...', delay: 80 },
  { text: '[  OK  ] Loading initramfs...', delay: 100 },
  { text: '[  OK  ] Starting TUX Desktop Environment...', delay: 150 },
  { text: '', delay: 200 },
];

const GRUB_MENU = `
                    GNU GRUB  version 2.06

 ┌──────────────────────────────────────────────────────────────┐
 │ *TUX OS (default)                                            │
 │  TUX OS (recovery mode)                                      │
 │  Windows Boot Manager (on /dev/sda2)                         │
 │                                                              │
 │                                                              │
 │                                                              │
 └──────────────────────────────────────────────────────────────┘

      Use the ↑ and ↓ keys to select which entry is highlighted.
      Press enter to boot the selected OS.

`;

export const BootScreen = ({ onBootComplete }) => {
  const [messages, setMessages] = useState([]);
  const [showGrub, setShowGrub] = useState(false);
  const [bootPhase, setBootPhase] = useState('bios'); // 'bios', 'grub', 'boot', 'done'

  useEffect(() => {
    let currentIndex = 0;
    let totalDelay = 0;

    // Phase 1: BIOS messages
    BOOT_MESSAGES.forEach((msg, index) => {
      totalDelay += msg.delay;
      setTimeout(() => {
        setMessages(prev => [...prev, msg.text]);
        currentIndex = index;
      }, totalDelay);
    });

    // Phase 2: Show GRUB menu
    setTimeout(() => {
      setBootPhase('grub');
      setShowGrub(true);
    }, totalDelay + 300);

    // Phase 3: Auto-boot after GRUB
    setTimeout(() => {
      setShowGrub(false);
      setBootPhase('boot');
    }, totalDelay + 1300);

    // Phase 4: Complete boot
    setTimeout(() => {
      setBootPhase('done');
      onBootComplete();
    }, totalDelay + 1800);

  }, [onBootComplete]);

  if (bootPhase === 'done') return null;

  return (
    <div className="fixed inset-0 bg-background z-50 overflow-hidden font-mono">
      {/* CRT scanline effect */}
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div 
          className="absolute inset-0"
          style={{
            background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 255, 102, 0.03) 2px, rgba(0, 255, 102, 0.03) 4px)'
          }}
        />
      </div>

      <div className="relative h-full p-4 overflow-hidden">
        {showGrub ? (
          // GRUB Menu
          <div className="flex items-center justify-center h-full">
            <pre className="text-primary text-glow text-sm whitespace-pre">
              {GRUB_MENU}
            </pre>
          </div>
        ) : (
          // BIOS/Boot messages
          <div className="text-primary text-sm leading-relaxed">
            {messages.map((msg, index) => (
              <div 
                key={index} 
                className="boot-text text-glow-subtle"
                style={{ animationDelay: `${index * 10}ms` }}
              >
                {msg === '' ? <br /> : msg}
              </div>
            ))}
            {bootPhase === 'boot' && (
              <div className="mt-4 text-glow">
                <span>Booting TUX OS</span>
                <span className="cursor-blink ml-1">_</span>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Screen flicker on phase change */}
      {bootPhase === 'boot' && (
        <div className="absolute inset-0 bg-primary opacity-5 flicker pointer-events-none" />
      )}
    </div>
  );
};
